import { render, staticRenderFns } from "./AllPeople.vue?vue&type=template&id=3396b452&scoped=true&"
import script from "./AllPeople.vue?vue&type=script&lang=js&"
export * from "./AllPeople.vue?vue&type=script&lang=js&"
import style0 from "./AllPeople.vue?vue&type=style&index=0&id=3396b452&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3396b452",
  null
  
)

export default component.exports